import { render, staticRenderFns } from "./ModalNotifVisitor.vue?vue&type=template&id=432f7670&lang=pug&"
import script from "./ModalNotifVisitor.vue?vue&type=script&lang=js&"
export * from "./ModalNotifVisitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports